import { ApplicationConfig, provideZoneChangeDetection } from "@angular/core";
import {
  provideRouter,
  withPreloading,
  PreloadAllModules,
} from "@angular/router";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { apiInterceptor } from "./api-interceptor.function";

import { routes } from "./app.routes";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { providePrimeNG } from "primeng/config";
import { MessageService } from "primeng/api";
import { QPilotBrandBridgePreset } from "../my-theme";
import { provideMonacoEditor } from "ngx-monaco-editor-v2";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideAnimations(),
    provideHttpClient(withInterceptors([apiInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        preset: QPilotBrandBridgePreset,
        options: {
          darkModeSelector: false || "none",
        },
      },
    }),
    MessageService, // Required for PrimeNG Toast component
    provideMonacoEditor({
      // Use CDN for Monaco to avoid web worker URL resolution issues with local assets
      // The AMD build's workers don't properly resolve relative paths
      baseUrl: "https://cdn.jsdelivr.net/npm/monaco-editor@0.52.0/min/vs",
    }),
  ],
};
